// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dateWidth_H3swJ {
  position: absolute;
  width: 100%;
  top: 0px !important;
}
.selectWidth_rzCw4 {
  width: 150px;
}
.iconStyle_BoH2Y {
  font-size: 18px;
}
.advancesearchStyle_hPIPq {
  margin-bottom: 20px;
}
.payeDrowpDownWidth_gR8j4 {
  position: absolute;
  width: 100%;
  top: 0px !important;
}
.currentstatus_it3uq {
  font-size: 12px;
  background-color: #ffefd3;
  color: #bf913c;
  width: 70px;
  margin-bottom: 3px;
  margin-top: 3px;
}
.ServiceProcessCradButton_qZMew {
  font-size: 22px;
}
.hederText_i7BxG {
  font-size: 25px;
  font-weight: 700;
}
.heder_ztmi9 {
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.missingInfomation_acTPu {
  padding: 20px;
  width: 100%;
  background-color: #fae8e3;
  margin-bottom: 20px;
  color: #838ba1;
  font-size: 18px;
}
.cardContainer_qXcwU {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}
.revertButtn_o5lVh {
  margin-top: 35px !important;
}
.cardWidth_RF9oe {
  width: 23%;
  display: flex;
  height: 180px;
  background-color: #f2f6fa;
  border-radius: 8px;
  color: #838591;
  position: relative;
  margin: 20px 18px 60px 0px;
}
.circle_rvtOw {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid #838ba1;
  text-align: center;
  margin-top: 10px;
  margin-left: 15px;
  position: relative;
}
.circle2_T3ZN8 {
  cursor: pointer;
  margin-top: 10px;
  position: absolute;
  /* Set position to absolute */
  top: 0;
  /* Position from the top edge */
  right: 0;
  margin-right: 10px;
}
.iconStyleSvg_EJic1 {
  width: 20px;
  height: 20px;
}
.ptagStyle_NTG3v {
  font-size: 11px;
  margin-top: 10px;
  top: 0;
  line-height: 15px;
}
.pheding_oNOo1 {
  font-size: 16px;
  font-weight: 600;
}
.textStyle_oDF3T {
  margin-left: 15px;
  line-height: 0px;
}
.contentWrapper_DJXLG {
  display: flex;
  /* Set display to flex */
  margin-top: 50px;
  margin-left: 15px;
  position: absolute;
}
.historyButton_g3hLD {
  width: 200px;
  height: 75px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 30px;
}
.buttontext_XfxgB {
  font-size: 30px;
  font-weight: 700;
  margin-right: 'auto';
}
.invoice_BWxod {
  width: 20px;
  height: 18px;
  cursor: pointer;
}
.currentstatus2_bUAfX {
  font-size: 12px;
  background-color: #ffefd3;
  color: #b68126;
  padding: auto;
  margin-bottom: 3px;
  margin-top: 3px;
}
.currentstatus3_F9jWj {
  font-size: 12px;
  background-color: #ddecfd;
  color: #5dbefa;
  padding: auto;
  width: 50px;
  margin-bottom: 0px;
  margin-top: 3px;
}
.currentstatus4_zv5PG {
  font-size: 12px;
  background-color: #d5f7ed;
  color: #4b9376;
  padding: auto;
  margin-bottom: 3px;
  margin-top: 3px;
}
.AssignInfoMontly_yrRH3 {
  font-size: 12px;
  background-color: #f2bcda;
  color: #fd49b2;
  padding: auto;
  margin-bottom: 3px;
  margin-top: 3px;
}
.misstingInfo_DV9fz {
  padding: 20px;
  width: 100%;
  background-color: #fae8e3;
  margin-bottom: 20px;
  color: #838ba1;
  font-size: 13px;
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ThingToDoViewAll/tingtodo.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACA;EACI,YAAA;AACJ;AACA;EACI,eAAA;AACJ;AACA;EACI,mBAAA;AACJ;AACA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AACJ;AACA;EACI,eAAA;AACJ;AACA;EACI,eAAA;EACA,gBAAA;AACJ;AACA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;AACA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACA;EACI,2BAAA;AACJ;AACA;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;AACJ;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAEA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EAAF,6BAA6B;EAC3B,MAAA;EACF,+BAA+B;EAA7B,QAAA;EACA,kBAAA;AAEJ;AAAA;EACI,WAAA;EACA,YAAA;AAEJ;AAAA;EACI,eAAA;EACA,gBAAA;EACA,MAAA;EACA,iBAAA;AAEJ;AAAA;EACI,eAAA;EACA,gBAAA;AAEJ;AAAA;EACI,iBAAA;EACA,gBAAA;AAEJ;AAAA;EACI,aAAA;EAEF,wBAAwB;EADtB,gBAAA;EACA,iBAAA;EACA,kBAAA;AAGJ;AADA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAGJ;AADA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AAGJ;AADA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAGJ;AADA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAGJ;AAAA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAEJ;AAAA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAEJ;AAAA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAEJ;AAAA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAEJ","sourcesContent":[".dateWidth {\n    position: absolute;\n    width: 100%;\n    top: 0px !important;\n}\n.selectWidth {\n    width: 150px;\n}\n.iconStyle {\n    font-size: 18px;\n}\n.advancesearchStyle {\n    margin-bottom: 20px;\n}\n.payeDrowpDownWidth {\n    position: absolute;\n    width: 100%;\n    top: 0px !important;\n}\n.currentstatus {\n    font-size: 12px;\n    background-color: #ffefd3;\n    color: #bf913c;\n    width: 70px;\n    margin-bottom: 3px;\n    margin-top: 3px;\n}\n.ServiceProcessCradButton {\n    font-size: 22px;\n}\n.hederText {\n    font-size: 25px;\n    font-weight: 700;\n}\n.heder {\n    margin-top: 10px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n}\n.missingInfomation {\n    padding: 20px;\n    width: 100%;\n    background-color: #fae8e3;\n    margin-bottom: 20px;\n    color: #838ba1;\n    font-size: 18px;\n}\n.cardContainer {\n    display: flex;\n    flex-wrap: wrap;\n    position: relative;\n    width: 100%;\n}\n.revertButtn {\n    margin-top: 35px !important;\n}\n.cardWidth {\n    width: 23%;\n    display: flex;\n    height: 180px;\n    background-color: #f2f6fa;\n    border-radius: 8px;\n    color: #838591;\n    position: relative;\n    margin: 20px 18px 60px 0px;\n}\n.circle {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid #838ba1;\n    text-align: center;\n    margin-top: 10px;\n    margin-left: 15px;\n    position: relative;\n}\n\n.circle2 {\n    cursor: pointer;\n    margin-top: 10px;\n    position: absolute; /* Set position to absolute */\n    top: 0; /* Position from the top edge */\n    right: 0;\n    margin-right: 10px;\n}\n.iconStyleSvg {\n    width: 20px;\n    height: 20px;\n}\n.ptagStyle {\n    font-size: 11px;\n    margin-top: 10px;\n    top: 0;\n    line-height: 15px;\n}\n.pheding {\n    font-size: 16px;\n    font-weight: 600;\n}\n.textStyle {\n    margin-left: 15px;\n    line-height: 0px;\n}\n.contentWrapper {\n    display: flex; /* Set display to flex */\n    margin-top: 50px;\n    margin-left: 15px;\n    position: absolute;\n}\n.historyButton {\n    width: 200px;\n    height: 75px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n.buttontext {\n    font-size: 30px;\n    font-weight: 700;\n    margin-right: 'auto';\n}\n.invoice {\n    width: 20px;\n    height: 18px;\n    cursor: pointer;\n}\n.currentstatus2 {\n    font-size: 12px;\n    background-color: #ffefd3;\n    color: #b68126;\n    padding: auto;\n    margin-bottom: 3px;\n    margin-top: 3px;\n}\n\n.currentstatus3 {\n    font-size: 12px;\n    background-color: #ddecfd;\n    color: #5dbefa;\n    padding: auto;\n    width: 50px;\n    margin-bottom: 0px;\n    margin-top: 3px;\n}\n.currentstatus4 {\n    font-size: 12px;\n    background-color: #d5f7ed;\n    color: #4b9376;\n    padding: auto;\n    margin-bottom: 3px;\n    margin-top: 3px;\n}\n.AssignInfoMontly {\n    font-size: 12px;\n    background-color: #f2bcda;\n    color: #fd49b2;\n    padding: auto;\n    margin-bottom: 3px;\n    margin-top: 3px;\n}\n.misstingInfo {\n    padding: 20px;\n    width: 100%;\n    background-color: #fae8e3;\n    margin-bottom: 20px;\n    color: #838ba1;\n    font-size: 13px;\n    border-radius: 8px;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateWidth": `dateWidth_H3swJ`,
	"selectWidth": `selectWidth_rzCw4`,
	"iconStyle": `iconStyle_BoH2Y`,
	"advancesearchStyle": `advancesearchStyle_hPIPq`,
	"payeDrowpDownWidth": `payeDrowpDownWidth_gR8j4`,
	"currentstatus": `currentstatus_it3uq`,
	"ServiceProcessCradButton": `ServiceProcessCradButton_qZMew`,
	"hederText": `hederText_i7BxG`,
	"heder": `heder_ztmi9`,
	"missingInfomation": `missingInfomation_acTPu`,
	"cardContainer": `cardContainer_qXcwU`,
	"revertButtn": `revertButtn_o5lVh`,
	"cardWidth": `cardWidth_RF9oe`,
	"circle": `circle_rvtOw`,
	"circle2": `circle2_T3ZN8`,
	"iconStyleSvg": `iconStyleSvg_EJic1`,
	"ptagStyle": `ptagStyle_NTG3v`,
	"pheding": `pheding_oNOo1`,
	"textStyle": `textStyle_oDF3T`,
	"contentWrapper": `contentWrapper_DJXLG`,
	"historyButton": `historyButton_g3hLD`,
	"buttontext": `buttontext_XfxgB`,
	"invoice": `invoice_BWxod`,
	"currentstatus2": `currentstatus2_bUAfX`,
	"currentstatus3": `currentstatus3_F9jWj`,
	"currentstatus4": `currentstatus4_zv5PG`,
	"AssignInfoMontly": `AssignInfoMontly_yrRH3`,
	"misstingInfo": `misstingInfo_DV9fz`
};
export default ___CSS_LOADER_EXPORT___;
